(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    
    var headerElement = document.getElementById('SiteHeaderWrapper');
    var lastScrollTop = 0;
    var ticking = false;

    function updateHeaderOnScroll() {
      var currentScroll = window.pageYOffset || document.documentElement.scrollTop;
      
      if (!headerElement) {
        ticking = false;
        return;
      }

      if (currentScroll > 150 && currentScroll > lastScrollTop) {
        headerElement.classList.add('is-hidden');
      } else {
        headerElement.classList.remove('is-hidden');
      }

      lastScrollTop = currentScroll <= 0 ? 0 : currentScroll;
      ticking = false;
    }

    window.addEventListener('scroll', function() {
      if (!ticking) {
        window.requestAnimationFrame(updateHeaderOnScroll);
        ticking = true;
      }
    }, { passive: true });

    updateHeaderOnScroll();

    var openDrawer = document.getElementById('DrawerOpenBtn');
    var closeDrawer = document.getElementById('DrawerCloseBtn');
    var drawerOverlay = document.getElementById('DrawerOverlay');

    function closeNavigationDrawer() {
      if(drawerOverlay) {
        drawerOverlay.classList.remove('is-open');
        document.body.style.overflow = '';
      }
    }

    if(openDrawer && drawerOverlay) {
      openDrawer.addEventListener('click', function() {
        drawerOverlay.classList.add('is-open');
        document.body.style.overflow = 'hidden';
      });
    }

    if(closeDrawer) {
      closeDrawer.addEventListener('click', closeNavigationDrawer);
    }

    if(drawerOverlay) {
      drawerOverlay.addEventListener('click', function(e) {
        if(e.target === drawerOverlay) {
          closeNavigationDrawer();
        }
      });
    }

    var searchTrigger = document.getElementById('HeaderSearchTrigger');
    var searchClose = document.getElementById('CloseSearchOverlay');
    var searchOverlay = document.getElementById('SearchOverlay');
    var searchInput = document.getElementById('SearchOverlayInput');

    function closeSearchModal() {
      if(searchOverlay) {
        searchOverlay.classList.remove('is-open');
        document.body.style.overflow = '';
      }
    }

    if(searchTrigger && searchOverlay) {
      searchTrigger.addEventListener('click', function(e) {
        e.preventDefault();
        searchOverlay.classList.add('is-open');
        document.body.style.overflow = 'hidden';
        if(searchInput) setTimeout(function() { searchInput.focus(); }, 100);
      });
    }

    if(searchClose) {
      searchClose.addEventListener('click', closeSearchModal);
    }

    if(searchOverlay) {
      searchOverlay.addEventListener('click', function(e) {
        if(e.target === searchOverlay) {
          closeSearchModal();
        }
      });
    }

    var storyTrigger = document.getElementById('HeaderStoryTrigger');
    var storyClose = document.getElementById('CloseStoryPopup');
    var storyOverlay = document.getElementById('StoryPopupOverlay');
    var prevBtn = document.getElementById('StoryPrevBtn');
    var nextBtn = document.getElementById('StoryNextBtn');
    var items = document.querySelectorAll('.story-slide-item');
    var progressFills = document.querySelectorAll('.story-progress-fill');
    
    var current = 0;
    var storyTimer = null;
    var progressInterval = null;
    var storyDuration = 5000;

    function resetProgressBars() {
      if(progressInterval) clearInterval(progressInterval);
      if(storyTimer) clearTimeout(storyTimer);

      progressFills.forEach(function(fill, idx) {
        if(idx < current) {
          fill.style.width = '100%';
        } else {
          fill.style.width = '0%';
        }
      });
    }

    function startProgress() {
      resetProgressBars();
      var currentFill = progressFills[current];
      if(!currentFill) return;

      var startTime = Date.now();

      progressInterval = setInterval(function() {
        var elapsed = Date.now() - startTime;
        var percentage = Math.min((elapsed / storyDuration) * 100, 100);
        currentFill.style.width = percentage + '%';

        if(elapsed >= storyDuration) {
          clearInterval(progressInterval);
          if(current < items.length - 1) {
            renderSlide(current + 1);
          } else {
            closeStoryPopupModal();
          }
        }
      }, 50);
    }

    function renderSlide(index) {
      if(!items.length) return;
      items.forEach(function(item) { item.classList.remove('is-visible'); });
      
      if(index >= items.length) {
        current = 0;
      } else if(index < 0) {
        current = items.length - 1;
      } else {
        current = index;
      }

      items[current].classList.add('is-visible');
      startProgress();
    }

    function openStoryPopupModal() {
      if(storyOverlay) {
        storyOverlay.classList.add('is-active');
        document.body.style.overflow = 'hidden';
        renderSlide(0);
      }
    }

    function closeStoryPopupModal() {
      if(storyOverlay) {
        storyOverlay.classList.remove('is-active');
        document.body.style.overflow = '';
        if(progressInterval) clearInterval(progressInterval);
        if(storyTimer) clearTimeout(storyTimer);
      }
    }

    if(storyTrigger) {
      storyTrigger.addEventListener('click', openStoryPopupModal);
    }

    if(storyClose) {
      storyClose.addEventListener('click', closeStoryPopupModal);
    }

    if(storyOverlay) {
      storyOverlay.addEventListener('click', function(e) {
        if(e.target === storyOverlay) {
          closeStoryPopupModal();
        }
      });
    }

    if(nextBtn) {
      nextBtn.addEventListener('click', function(e) {
        e.stopPropagation();
        if(current < items.length - 1) {
          renderSlide(current + 1);
        } else {
          closeStoryPopupModal();
        }
      });
    }

    if(prevBtn) {
      prevBtn.addEventListener('click', function(e) {
        e.stopPropagation();
        renderSlide(current - 1);
      });
    }

    document.addEventListener('shopify:block:select', function(event) {
      var selectedBlockId = event.detail.blockId;
      var targetSlide = document.querySelector('.story-slide-item[data-block-id="' + selectedBlockId + '"]');
      
      if(targetSlide && storyOverlay) {
        storyOverlay.classList.add('is-active');
        document.body.style.overflow = 'hidden';
        items.forEach(function(item, idx) {
          item.classList.remove('is-visible');
          if(item === targetSlide) {
            current = idx;
            item.classList.add('is-visible');
            startPlatform = startProgress();
          }
        });
      }
    });

    document.addEventListener('shopify:block:deselect', function() {
      closeStoryPopupModal();
    });

    document.addEventListener('shopify:section:deselect', function() {
      closeStoryPopupModal();
      closeNavigationDrawer();
      closeSearchModal();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
